import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedVacationDaysDocument,
  RemoveVacationDaysMutation,
  RemoveVacationDaysMutationVariables,
  RemoveVacationDaysDocument,
} from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for removing a vacation day and handling the necessary cache updates.
 * @returns {Object} - Contains the removeVacationDayMutation function, loading state, and error state.
 */
export default function useRemoveVacationDayMutationHook(): {
  removeVacationDayMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [removeVacationDayMutation, { loading, error }] = useMutation<RemoveVacationDaysMutation, RemoveVacationDaysMutationVariables>(
    RemoveVacationDaysDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedVacationDays");

        toast(CustomToastComponent, {
          toastId: "vacation-day-removed-success",
          data: {
            title: t("toasts.vacationdaysremovedsuccessfully"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: PaginatedVacationDaysDocument,
          variables: {
            first: 10,
            currentPage: 0,
            after: null,
            filters: {
              activeFrom: null,
              lengthOfEmployment: null,
              days: null,
              provinces: null,
            },
            sort: null,
          },
        },
      ],
    });

  return {
    removeVacationDayMutation,
    loading,
    error,
  };
}
